import { render } from "./PaymentsList.vue?vue&type=template&id=2d505b18&scoped=true"
import script from "./PaymentsList.vue?vue&type=script&lang=js"
export * from "./PaymentsList.vue?vue&type=script&lang=js"

import "./PaymentsList.vue?vue&type=style&index=0&id=2d505b18&scoped=true&lang=css"

import exportComponent from "/home/runner/work/somosteatro/somosteatro/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d505b18"]])

export default __exports__